import { render } from "./DefaultDetail.vue?vue&type=template&id=e40612a6"
import script from "./DefaultDetail.vue?vue&type=script&lang=js"
export * from "./DefaultDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Kaung\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__